export default __webpack_public_path__ + "img/7acb1afebb7df9e3cbddd0cc37d6271a.png";